document.addEventListener('DOMContentLoaded', () => {
  // select first option in subscription - for all variants (if any)
  // layer:
  // - variant-select (8, 4, 2, 1)
  //   - subscription (1, 2, 3)
  const onSubscriptionChange = (info) => {
    const targetIndex = parseInt(info.target.getAttribute('data-subscription-index'), 10)
    const variants = document.querySelectorAll('variant-selects > fieldset > div > input[type="radio"]')
    const subscriptionSections = document.querySelectorAll('.shopify_subscriptions_app_block_label_children > li > label > input[type="radio"]')
    for (let v = 0; v < variants.length; v++) {
      const sLen = subscriptionSections.length / variants.length
      for (let s = 0; s < sLen; s++) {
        let vs = (v * sLen) + s
        if (vs >= subscriptionSections.length) {
          // safety check
          continue
        }
        const subscriptionSection = subscriptionSections[vs]
        const variantIndex = subscriptionSection.getAttribute('data-variant-index')
        const subscriptionIndex = parseInt(subscriptionSection.getAttribute('data-subscription-index'), 10)
        if (subscriptionIndex !== targetIndex) {
          continue
        }
        // const variantIndex = subscriptionSection.getAttribute('data-variant-index')
        if (subscriptionIndex === s) {
          subscriptionSection.checked = true
          // subscriptionSection.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    }
  }

  const refreshSubscription = () => {
    const variants = document.querySelectorAll('variant-selects > fieldset > div > input[type="radio"]')
    const subscriptionSections = document.querySelectorAll('.shopify_subscriptions_app_block_label_children > li > label > input[type="radio"]')
    for (let v = 0; v < variants.length; v++) {
      const sLen = subscriptionSections.length / variants.length
      for (let s = 0; s < sLen; s++) {
        let vs = (v * sLen) + s
        if (vs >= subscriptionSections.length) {
          // safety check
          continue
        }
        const subscriptionSection = subscriptionSections[vs]
        subscriptionSection.setAttribute('data-variant-index', v)
        subscriptionSection.setAttribute('data-subscription-index', s)
        subscriptionSection.addEventListener('change', onSubscriptionChange)
        if (s !== 0) {
          // only select first subscription option
          continue
        }
        subscriptionSection.checked = true
        subscriptionSection.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }
  }
  refreshSubscription()

  // const refreshPriceItems = () => {
  //   const priceItems = document.querySelectorAll('.price-item')
  //   for (const priceItem of priceItems) {
  //     if (priceItem.innerHTML.includes('USD')) {
  //       priceItem.innerHTML = priceItem.innerHTML.replace(' USD', '')
  //     }
  //   }
  // }
  
  // const pushState = history.pushState
  // history.pushState = function () {
  //   pushState.apply(history, arguments)
  //   window.dispatchEvent(new Event('urlchange'))
  // }
  // window.addEventListener('urlchange', () => {
  //   refreshPriceItems()
  // })
  // refreshPriceItems()
})